var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6277 32.1421C25.4711 32.1421 32.6402 24.9731 32.6402 16.1297C32.6402 7.28621 25.4711 0.117188 16.6277 0.117188C7.78426 0.117188 0.615234 7.28621 0.615234 16.1297C0.615234 24.9731 7.78426 32.1421 16.6277 32.1421Z",
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6264 23.0006H21.8995V17.2216C21.8995 15.8436 21.8747 14.0696 19.9612 14.0696C18.0201 14.0696 17.7231 15.571 17.7231 17.1213V23.0002H13.9962V11.1163H17.574V12.7404H17.6241C17.9821 12.1342 18.4995 11.6355 19.1212 11.2975C19.7428 10.9594 20.4454 10.7947 21.1541 10.8207C24.9315 10.8207 25.6279 13.2808 25.6279 16.4813L25.6264 23.0006ZM9.79106 9.49188C9.36331 9.49196 8.94513 9.36644 8.58943 9.1312C8.23373 8.89595 7.95648 8.56155 7.79272 8.17028C7.62895 7.77901 7.58603 7.34845 7.66941 6.93303C7.75278 6.51762 7.9587 6.13601 8.26112 5.83647C8.56353 5.53693 8.94886 5.33291 9.36837 5.25021C9.78789 5.1675 10.2227 5.20984 10.618 5.37185C11.0132 5.53386 11.351 5.80827 11.5887 6.16039C11.8264 6.51251 11.9534 6.92651 11.9534 7.35005C11.9535 7.63127 11.8976 7.90974 11.7889 8.16957C11.6803 8.42941 11.521 8.66551 11.3203 8.86439C11.1195 9.06328 10.8811 9.22106 10.6187 9.32872C10.3563 9.43639 10.0751 9.49183 9.79106 9.49188ZM11.6545 23.0006H7.92375V11.1163H11.6545V23.0006Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.615234 0.117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.5ccb27bd35d3204c9f0d215b5ae6a38f.svg";
export { ForwardRef as ReactComponent };